import React from 'react';
import PropTypes from 'prop-types';
import Field from 'redux-form/es/Field';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import cx from 'classnames';
import Button from 'components/common/Button';
import InputField from 'components/Credit24/Core/Controls/InputField';
import CheckboxInput from 'components/Credit24/Core/Controls/CheckboxInput';
import MarketingConsentsGroup from 'components/Credit24/LoanApplication/MarketingConsentsGroup';
import ConsentsEE from 'components/Credit24/LoanApplication/HomePage/ConsentsEE';

const propTypes = {
  marketingConsents: PropTypes.array.isRequired,
  skip: PropTypes.func.isRequired,
  signUpGateSubmitted: PropTypes.bool,
  showAdtractionPermission: PropTypes.bool,
  campaignMessage: PropTypes.string,
  isServiceUnavailable: PropTypes.bool,
  backgroundColor: PropTypes.string,
};

const defaultProps = {
  signUpGateSubmitted: false,
  showAdtractionPermission: false,
  isServiceUnavailable: false,
};

const loanFormClasses = cx({
  'loan-form': true,
  'loan-form--embedded': EMBEDDED,
});

const SignupGate = (props) => {
  const {
    marketingConsents,
    skip,
    signUpGateSubmitted,
    showAdtractionPermission,
    campaignMessage,
    isServiceUnavailable,
    backgroundColor,
  } = props;

  const containerStyles = {};

  if (EMBEDDED) {
    containerStyles.background = backgroundColor || 'none';
  }

  return (
    <>
      <header className="homepage__header">
        <div className="container">
          {EMBEDDED && campaignMessage
            ? <h1 className="homepage__title txt-center" dangerouslySetInnerHTML={{ __html: campaignMessage }} />
            : (
              <h1 className="homepage__title txt-center">
                <FormattedMessage id="personal.offer" />
              </h1>
            )}
        </div>
      </header>
      <div className="homepage__container homepage__container--no-tabs" style={containerStyles}>
        <div className="homepage__content">
          <div className="container container--mobile-fullWidth">
            <div className="grid grid--center">
              <div className="grid__item three-quarters portable-one-whole">
                <div className={loanFormClasses}>
                  <div className="loan-form__step">
                    <div className="loan-form__step-body loan-form__step-body--with-shadow">
                      {signUpGateSubmitted
                        && (
                        <p className="txt-center">
                          <FormattedHTMLMessage id="signupgate.thank_you.text" />
                        </p>
                        )}
                      <Field
                        title={<FormattedMessage id="signupgate.name" />}
                        name="sugName"
                        type="text"
                        component={InputField}
                        isFullWidth
                        autoFocus
                        isErrorVisible
                      />
                      <Field
                        title={<FormattedMessage id="signupgate.email" />}
                        name="sugEmail"
                        type="email"
                        component={InputField}
                        isFullWidth
                        isErrorVisible
                      />
                      <Field
                        title={<FormattedMessage id="signupgate.phone" />}
                        hint={<FormattedMessage id="hint.field.msisdn" />}
                        name="sugMsisdn"
                        type="tel"
                        component={InputField}
                        isFullWidth
                        isErrorVisible
                      />
                      {showAdtractionPermission && (
                        <p>
                          <Field
                            name="sugAdtractionMarketingPermission"
                            component={CheckboxInput}
                            text={(
                              <FormattedHTMLMessage id="signupgate.marketing_adtraction_permission" />
                            )}
                          />
                        </p>
                      )}
                      {COUNTRY === 'FI'
                        ? <MarketingConsentsGroup consents={marketingConsents} />
                        : (
                          <p>
                            <Field
                              name="sugMarketingPermission"
                              component={CheckboxInput}
                              text={(
                                <FormattedHTMLMessage id="signupgate.marketing_permissions" />
                              )}
                            />
                          </p>
                        )}
                      {COUNTRY === 'EE' && <ConsentsEE />}
                      <div className="btn-group txt-right">
                        {COUNTRY === 'FI' && !isServiceUnavailable
                          && (
                          <Button btnType="secondary" onClick={skip} type="button">
                            <FormattedMessage id="navigation.skip" />
                          </Button>
                          )}
                        <Button
                          disabled={signUpGateSubmitted}
                        >
                          <FormattedMessage id="navigation.continue" />
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

SignupGate.propTypes = propTypes;
SignupGate.defaultProps = defaultProps;

export default SignupGate;
